<template>
	<div class="topbar">
		<a class="topbar-logo" href="/">
			<img src="https://s3.wandougongzhu.cn/s/76/logo_f4ff9b.png" />
			<span>豌豆公主 - 入库管理后台</span>
		</a>
		<div class="topbar-userinfo">
			<i class="el-icon-user"></i> {{username}}	
			<span class="logout" @click="logout">退出登录</span>		
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			username: ''
		};
	},
	created() {
		let username = localStorage.getItem('username');
		if(username) {
			this.username = username;
		}
	},
	methods: {
		logout() {
			localStorage.setItem('username', '');
			this.$router.push({
				path: '/login'
			});
			location.reload();
		}
	}
};
</script>


<style>
	.topbar {
		height: 64px;
		background-color: #171f2c;
		box-shadow: 0 0 10px 0 rgba(0,0,0,.6);
		color: #ffffff;
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 99;
		display: flex;
	}
	.topbar-logo {
		height: 64px;
		width: 400px;
		display: flex;
		font-size: 18px;
		color: #fff;
		align-items: center;
		padding-left: 10px;
		background-color: #171f2c;
		text-decoration: none;
	}
	.topbar img {
		margin-right: 20px;
		width: 40px;
		height: 40px;
	}
	.topbar-userinfo {
		flex: 1;
		text-align: right;
		color: #ffffff;
		line-height: 64px;
		margin-right: 10px;
	}
	.logout {
		margin-left: 20px;
		font-size: 14px;
	}
</style>

